<template>
  <div id="detailed-cart">
    <SfModal :title="$t('select_gift')" v-if="msOpen" :visible="msOpen"  overlay transitionModal="sf-fade"
      transitionOverlay="sf-fade" :persistent="false" class="mansongItem">
      <template #modal-bar>
        <div class="title" style="text-align:center;">
          <h4 style="padding:2rem;padding-top:1rem;margin:0;padding-bottom:0;">{{ $t('select_gift') }}</h4>
        </div>
      </template>
      <template #close>
        <div >
          <!-- <sf-icon icon="cross" size="1.25rem" @click="close" /> -->
        </div>
      </template>
      <template #default>
        <div style="height: 70vh" class="item-list">
          <SfProductCard v-for="goods in gift_goods" :key="goods.good_id" :image="goods.imageUrl" imageWidth="100"
            imageHeight="100" :title="goods.title" :wishlistIcon="false" isInWishlistIcon="heart_fill">
            <template #price>
              <div style="min-height: 30px">
                <Sku :goodInfo="goods" :showBtn="false" :showMs="true" @changeSelectedSku="changeSelectedSku"
                  @backSku="clickMsItem" hidePost />
              </div>
            </template>
          </SfProductCard>
        </div>
      </template>
    </SfModal>
    <newOrderSummary class="NewSummary" :orderTitle="$t('Promo_code')" :orderTitleLevel="2" :order="order"  @click:apply-code="clickCode" ref="code" :showOrderSumPrice="false">
      <template #heading>
       <div style="margin-bottom:1rem;">
         <div v-if="preorder">
          <SfAccordion class="productAcction isMobileShow " v-if="false">
            <SfAccordionItem class="filters__accordion-item" :header="$t('showOrderSummary')">
              <div slot="additional-info">
                <div>
                  <div>
                    {{ $n(preorder.payment, 'currency') }}
                  </div>
                </div>
              </div>
              <div v-for="order in preorder.orders" :key="order.orderId">
                <SfHeading
                  :level="3"
                  :title="order.shop.title"
                  class="sf-heading--left sf-heading--no-underline title"
                />
                <div v-for="item in order.orderItem" :key="item.skuId" style="margin-bottom: 0.5rem;" >
                  <div class="item-row">
                    <div style="position: relative;width: 64px;">
                      <SfImage :src="item.imgUrl" alt="" style="height:64px;width: 64px;" class="orderImg"/>
                      <SfBadge v-if="item.num" class="sf-badge--number cart-badge" style="position: absolute;top:-0.6rem;right:-0.6rem;">{{ item.num }}</SfBadge>
                    </div>
                    <div class="item-cell" style="padding:0 0.65rem;">
                      <div class="title">{{ item.title }}</div>
                      <div class="descript">
                        {{ item.skuProp }}
                      </div>
                      <div class="price">{{ $n(item.price, 'currency') }}</div>
                    </div>
                    <!-- <div class="item-cell" style="flex: 0 auto;">
                      <div class="price">{{ $n(item.price, 'currency') }}</div>
                    </div> -->
                  </div>
                  <div
                    v-if="
                      preorder.goodsService &&
                      preorder.goodsService[order.shopId] &&
                      preorder.goodsService[order.shopId][item.skuId]
                    "
                    style="
                      width: 100%;
                      border-top: 1px solid #ccc;
                      margin-top: 0.5rem;
                      padding-top: 1rem;
                      padding-bottom: 1rem;
                    "
                    class="goodService"
                  >
                    <div
                      v-for="goodService in preorder.goodsService[order.shopId][
                        item.skuId
                      ]"
                      class="table__row"
                      style="display: flex; width: 100%; justify-content: flex-start;margin-bottom:0.5rem;align-items: center;"
                    >
                      <div class="table__image2" style="width: var(--image-width);display: flex;align-items: flex-end;">
                        <Sf-checkbox
                          v-e2e="'service_name'"
                          v-model="servicesList[item.skuId]"
                          :name="item.skuId + ''"
                          @change="
                            toggleServices(
                              item.skuId + '',
                              servicesList[item.skuId]
                            )
                          "
                          :value="goodService.service_id + ''"
                        >
                          <template #label>
                            <div class="sf-checkbox__label">
                              {{ goodService.service_name }}
                            </div>
                          </template>
                        </Sf-checkbox>
                      </div>
                      <div
                        class="table__data "
                        style="display: flex; flex: 1; align-items: flex-end"
                      >
                        <div
                          class="sf-checkbox__label"
                          style=" margin-left: 0;text-align: left;"
                        >
                          {{ goodService.description }}
                        </div>
                      </div>
                      <div
                        class="table__data"
                        style="
                          display: flex;
                          align-items: flex-end;
                          text-align: right;
                        "
                      >
                        <div
                          class="sf-checkbox__label"
                          style="width: 100%"
                        >
                          {{ $n(goodService.price, 'currency') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Vsf-shippingProvider
                  :addressId="address ? address.addressId: '0'"
                  :shopId="order.shopId"
                  style="margin-bottom: 1rem;"
                />
                <div v-if="InsuranceShow" style="border-top: 1px solid #ccc;padding-top:1rem;margin-bottom: 1rem;">
                  <SfCheckbox
                    v-if="InsuranceShow"
                    v-e2e="'hasInsurance'"
                    v-model="hasInsurance"
                    name="hasInsurance"
                    class="summary__terms"
                    @change="toggleInsurance"
                  >
                    <template #label>
                      <div class="sf-checkbox__label">
                        {{ $t('hasInsurance') }}
                      </div>
                    </template>
                  </SfCheckbox>
                  <div
                    style="margin-top: 20px"
                    class="summary"
                    v-if="order.insuranceFee > 0"
                  >
                    <div class="summary__group">
                      <div class="summary__total">
                        <SfProperty
                          :name="$t('payment_insurance_fee')"
                          :value="
                            $n(
                              order.insuranceFee > 0 ? order.insuranceFee : 0,
                              'currency'
                            )
                          "
                          class="sf-property--full-width property"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SfAccordionItem>
          </SfAccordion>
          <!-- class="isDesktopShow" -->
          <div >
              <div v-for="order in preorder.orders" :key="order.orderId">
                <SfHeading
                  :level="3"
                  :title="order.shop.title"
                  class="sf-heading--left sf-heading--no-underline title"
                />
                <div v-for="item in order.orderItem" :key="item.skuId" style="margin-bottom:0.75rem" >
                  <div class="item-row">
                    <div style="position: relative;width: 64px;">
                      <SfImage :src="item.imgUrl" alt="" style="height:64px;width: 64px;" class="orderImg"/>
                      <SfBadge v-if="item.num" class="sf-badge--number cart-badge" style="position: absolute;top:-0.6rem;right:-0.6rem;">{{ item.num }}</SfBadge>
                    </div>
                    <div class="item-cell" style="padding:0 0.65rem;">
                      <div class="title">{{ item.title }}</div>
                      <div class="descript">
                        {{ item.skuProp }}
                      </div>
                       <div style="margin-top:8px;" class="price">{{ $n(item.price, 'currency') }}</div>
                    </div>
                    <!-- <div class="item-cell" style="flex: 0 auto;">
                      <div class="price">{{ $n(item.price, 'currency') }}</div>
                    </div> -->
                  </div>
                  <div
                    v-if="
                      preorder.goodsService &&
                      preorder.goodsService[order.shopId] &&
                      preorder.goodsService[order.shopId][item.skuId]
                    "
                    style="
                      width: 100%;
                      border-top: 1px solid #ccc;
                      margin-top: 0.5rem;
                      padding-top: 1rem;
                      padding-bottom: 1rem;
                    "
                    class="goodService"
                  >
                    <div
                      v-for="goodService in preorder.goodsService[order.shopId][
                        item.skuId
                      ]"
                      class="table__row"
                      style="display: flex; width: 100%; justify-content: flex-start;margin-bottom:0.5rem;align-items: center;"
                    >
                      <div class="table__image2" style="width: var(--image-width);display: flex;align-items: flex-end;">
                        <Sf-checkbox
                          v-e2e="'service_name'"
                          v-model="servicesList[item.skuId]"
                          :name="item.skuId + ''"
                          @change="
                            toggleServices(
                              item.skuId + '',
                              servicesList[item.skuId]
                            )
                          "
                          :value="goodService.service_id + ''"
                        >
                          <template #label>
                            <div class="sf-checkbox__label">
                              {{ goodService.service_name }}
                            </div>
                          </template>
                        </Sf-checkbox>
                      </div>
                      <div
                        class="table__data "
                        style="display: flex; flex: 1; align-items: flex-end"
                      >
                        <div
                          class="sf-checkbox__label"
                          style=" margin-left: 0;text-align: left;"
                        >
                          {{ goodService.description }}
                        </div>
                      </div>
                      <div
                        class="table__data"
                        style="
                          display: flex;
                          align-items: flex-end;
                          text-align: right;
                        "
                      >
                        <div
                          class="sf-checkbox__label"
                          style="width: 100%"
                        >
                          {{ $n(goodService.price, 'currency') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Vsf-shippingProvider
                  :addressId="address ? address.addressId: '0'"
                  :shopId="order.shopId"
                  style="margin-bottom: 1rem;margin-top:1rem;"
                />
                <div v-if="InsuranceShow" style="border-top: 1px solid #ccc;padding-top:1rem;margin-bottom: 1rem;">
                  <SfCheckbox
                    v-if="InsuranceShow"
                    v-e2e="'hasInsurance'"
                    v-model="hasInsurance"
                    name="hasInsurance"
                    class="summary__terms"
                    @change="toggleInsurance"
                  >
                    <template #label>
                      <div class="sf-checkbox__label">
                        {{ $t('hasInsurance') }}
                      </div>
                    </template>
                  </SfCheckbox>
                  <div
                    style="margin-top: 20px"
                    class="summary"
                    v-if="order.insuranceFee > 0"
                  >
                    <div class="summary__group">
                      <div class="summary__total">
                        <SfProperty
                          :name="$t('payment_insurance_fee')"
                          :value="
                            $n(
                              order.insuranceFee > 0 ? order.insuranceFee : 0,
                              'currency'
                            )
                          "
                          class="sf-property--full-width property"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
       </div>
      </template>
      <template #characteristics>
        <div>
          <div v-if="couponList && couponList.length > 0" style="font-weight: 600;margin:0.5rem 0;">{{ $t('CouponCode') }}:</div>
          <div v-for="coupone in couponList" style="margin-bottom:0.5rem;">
            <SfCheckbox v-e2e="'coupons'" v-model="coupons" name="coupons" class="summary__terms"
              :value="coupone.promotion_code" @change="selecCouponeChange(coupone)">
              <template #label>
                <div style="margin-left:1rem;">
                  {{ coupone.promotion_code }}
                </div>
              </template>
            </SfCheckbox>
          </div>
        </div>
        <div>
          <!-- <SfProperty :name="$t(propertiesNames[0])" :value="totalItems"
            class="sf-property--full-width  sf-order-summary__property" /> -->
          <SfProperty v-if="order && order.subtotal" :name="$t(propertiesNames[1])" :value="$n(order.subtotal, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty v-if="order && order.shipping" :name="$t(propertiesNames[2])" :value="$n(order.shipping.shippingMethod.price, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty v-if="order && order.shipping && order.shipping.shippingMethod.postTaxFee > 0" :name="$t(propertiesNames[3])"
            :value="$n(order.shipping.shippingMethod.postTaxFee, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty v-if="order && order.shipping &&order.shipping.shippingMethod.insuranceFee > 0" :name="$t(propertiesNames[4])"
            :value="$n(order.shipping.shippingMethod.insuranceFee, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty v-if="order && order.shipping &&order.shipping.shippingMethod.insuranceTaxFee > 0" :name="$t(propertiesNames[5])"
            :value="$n(order.shipping.shippingMethod.insuranceTaxFee, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty v-if="order && order.discount > 0" :name="$t(propertiesNames[6])"
            :value="'-' + $n(order.discount, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <SfProperty style="margin-bottom: 0.5rem !important;" v-if="preorder" :name="$t(propertiesNames[7])" :value="$n(preorder.payment, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" />
          <!-- <SfDivider class="sf-order-summary__divider" /> -->
          <!-- <SfProperty :name="$t(propertiesNames[7])" :value="$n(total, 'currency')"
            class="sf-property--full-width  sf-order-summary__property" /> -->
        </div>
        <!-- <div v-if="promoCode && promoCode.length" >
          <div style="font-weight: 600;margin-bottom:0.5rem;">{{ $t('currentUseCode') }}:</div>
          <div v-for="(code, key) in promoCode" :key="key" class="codeList"
            style="display: flex;align-items: center;margin-bottom:0.5rem;">
            <div style="border: 1px solid #000;padding:4px;">
              <SfIcon style="height:16px;width:16px;" aria-hidden="true" color="green-primary" size="xs" icon="cross"
                @click="delCode(code)" />
            </div>
            <div style="flex: 1;margin-left:1rem;">{{ code }}</div>
          </div>
        </div> -->
        
        <div style="border-bottom:1px solid #ccc;margin-top:1rem;"></div>
      </template>
    </newOrderSummary>
    <div v-if="payImage">
      <img :src="payImage" />
    </div>
  </div>
</template>
<script>
import {
  SfModal,
  SfProductCard,
  SfCharacteristic,
  SfIcon,
  SfCheckbox,
  SfImage,
  SfBadge,
  SfPrice,
  SfProperty,
  SfDivider,
  SfHeading,
  SfAccordion
} from '@storefront-ui/vue';
import VsfShippingProvider from '~/components/Checkout/VsfShippingProvider';
import { usePreviewOrder, useMakeOrder, orderGetters, useBenefitCode, useBenbefitCodeList, useClaimBenfitCode } from '@bee-hole/coms';
import {
  computed,
  onUnmounted,
  ref,
  useRoute,
  onMounted
} from '@nuxtjs/composition-api';
import Sku from '~/components/Sku/Sku';
import newOrderSummary from '~/components/Checkout/newOrderSummary';
import { usePreOrderStore } from '~/stores/newPreOrder';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'CartPreview',
  components: {
    newOrderSummary,
    SfModal,
    SfProductCard,
    Sku,
    SfCharacteristic,
    SfIcon,
    SfCheckbox,
    SfImage,
    SfBadge,
    SfPrice,
    SfProperty,
    SfDivider,
    SfHeading,
    VsfShippingProvider,
    SfAccordion
  },
  setup(props, { root }) {
    const route = useRoute();
    const { order: finalOrder } = useMakeOrder();
    const { getCodelist, list } = useBenbefitCodeList();
    const { claimBenefitCode, claimResult } = useClaimBenfitCode();
    const msOpen = ref(false);
    const gift_goods = ref();
    const payImage = computed(() => {
      if (finalOrder?.value?.native_prepay?.native_code) {
        return 'data:image/jpeg;base64, ' + finalOrder?.value?.native_prepay?.native_code;
      }
    });
    const { preorder } = usePreviewOrder();
    const preOrderStore = usePreOrderStore();
    const { addCode, result, error: codeErr } = useBenefitCode();
    // 收货地址
    const address = computed(() => preOrderStore.address);
    // 保险
    const InsuranceShow = computed(() => root.$options?.$storeConfig?.mall_insurance_enable === '1');
    const hasInsurance = ref(preOrderStore.hasInsurance || false);
    //
    // 服务列表
    const servicesList = ref(preOrderStore.services || {});
    // const coupons = ref(preorder?.value?.promoCodes || []);
    const coupons = computed(() => preorder?.value?.promoCodes ||[]);
    const promoCode = computed(() => preorder?.value?.promoCodes);
    // const order.shipping.shippingMethods = computed(() => preOrderStore?.order.shipping.shippingMethods);
    const code = ref();
    const currentCode = ref('');
    const couponList = computed(() => {
      // 去掉list数组中promotion_code相等的
      const couponsList = [];
      if (list.value && list.value?.length) {
        list.value?.map((item) => {
          if (couponsList.findIndex(coupon => coupon?.promotion_code === item?.promotion_code) === -1) {
            couponsList.push(item);
          }
        });
      }
      console.log('list', list)
      return couponsList;
    });
    const order = computed(() => {
      const order = preorder?.value?.orders?.length ? orderGetters.getOrderListSummaryOrder(preorder?.value) : {};
      return order
    });

    // 离开checkout页面清除previewKey
    onUnmounted(() => {
      if (route.value?.path?.indexOf('/checkout') === -1) {
        preOrderStore.clearpreviewId();
        preOrderStore.clearCode();
        preOrderStore.clearPreviewKey();
        // console.log('清除预览id', preOrderStore.state);
      } else {
        // console.log('还在预览页不清除预览id');
      }
    });
    const chuliGiftItem = () => {
      if (result.value?.promo_details && result.value?.promo_details?.length && result.value.promo_details[0].gift_goods && result.value.promo_details[0].gift_goods?.length) {
        gift_goods.value = result.value?.promo_details?.[0]?.gift_goods;
        // console.log('mansong', result.value?.promo_details?.[0]);
        msOpen.value = true;
      }
    };
    const pushCode = async (code) => {
      if (code) {
        await addCode({
          promotion_code: code.promoCode,
          adv_pay_id: preorder.value?.previewId,
          operate: 'use',
          preview_serial_id: preOrderStore?.previewKey
        });
        if (codeErr.value === null) {
          preOrderStore.setPromo_code(code.promoCode);
        }
        currentCode.value = code;
        EventBus.$emit('NewPreviewOrder', code);
        chuliGiftItem();
        return code;
        // console.log('value?.previewId code', result);
      }
    };
    const clickCode = async () => {
      if (code.value._data) {
        const res = await claimBenefitCode({ promo_code: code.value._data.promoCode,auto: false });
        await getCodelist();
        pushCode(code.value._data);
        // chuliGiftItem();
        // console.log('value?.previewId code', result);
      }
    };
    const autoPushBenefitCode = async () => {
      const codes = [];
      if (list.value?.length) {
        // 循环list 每一秒执行一次pushCode 同步执行
        list.value.map((item) => {
          if (item.benefit_type !== 3) {
            codes.push(item?.promotion_code);
          }
        });
        await addCode({
          promotion_code: codes,
          adv_pay_id: preorder.value?.previewId,
          operate: 'use',
          preview_serial_id: preOrderStore?.previewKey
        });
        if (codeErr.value === null) {
          preOrderStore.setPromo_codes(codes);
          // coupons.value = codes;
        }
        // currentCode.value = code;
        setTimeout(() => {
          chuliGiftItem();
          EventBus.$emit('NewPreviewOrder', codes);
        }, 200);
      }
    };
    // loadCart();
    onMounted(async () => {
      // await loadCart();
      // console.log('preorder-----------', order.value, preorder.value);
      await getCodelist();
      setTimeout(() => {
        if (preOrderStore?.previewKey) {
          autoPushBenefitCode();
        }
      // if (route.value?.path?.indexOf('/checkouts') !== -1) {
      //   if (!preOrderStore?.isAutoPromoCodePush && preOrderStore?.previewKey) {
      //     preOrderStore.setisAutoPromoCodePush(true);
      //     autoPushBenefitCode();
      //   }
      // } else {
      //   preOrderStore.setisAutoPromoCodePush(false);
      // }
      }, 1000);
      // 页面刷新的时候清除previewKey
      window.onbeforeunload = () => {
        // console.log('页面刷新的时候清除previewKey');
        preOrderStore.clearPreviewKey();
      };
    });

    const changeSelectedSku = () => {
      // console.log('changeSelectedSku', res);
    };
    const clickMsItem = async (item) => {
      // console.log('clickMsItem', item);
      await addCode({
        promotion_code: currentCode.value.promoCode,
        adv_pay_id: preorder.value?.previewId,
        operate: 'use',
        gift_items_summary: [{
          good_id: item.goodId,
          sku_id: item.sku.skuId,
          title: item.title,
          img_url: item.imageUrl,
          // sku_prop: item.sku_prop,
          num: 1
        }],
        preview_serial_id: preOrderStore?.previewKey
      });
      EventBus.$emit('NewPreviewOrder', code.value._data.promoCode);
      msOpen.value = false;
    };
    const delCode = async (code) => {
      preOrderStore.delCode(code);
      await addCode({
        promotion_code: code,
        adv_pay_id: preorder.value?.previewId,
        operate: 'del',
        preview_serial_id: preOrderStore?.previewKey
      });
      EventBus.$emit('NewPreviewOrder', code);
    };
    const selecCouponeChange = async (coupon) => {
      if (coupon?.promotion_code) {
        // console.log('coupons.value && coupons.value.indexOf(coupon?.promotion_code) !== -1', coupons.value && coupons.value.indexOf(coupon?.promotion_code) !== -1)
        if (coupons.value && coupons.value.indexOf(coupon?.promotion_code) == -1) {
          await pushCode({ promoCode: coupon?.promotion_code });
          chuliGiftItem();
          EventBus.$emit('NewPreviewOrder', coupon?.promotion_code);
        } else {
          delCode(coupon?.promotion_code);
        }
      }
    };
    // 点击服务单
    const toggleServices = (skuid, has) => {
      preOrderStore.setServices(skuid, (servicesList.value[skuid]));
      EventBus.$emit('NewPreviewOrder', (servicesList.value[skuid]));
    };
    const toggleInsurance = () => {
      preOrderStore.sethasInsurance(hasInsurance.value);
      EventBus.$emit('NewPreviewOrder', hasInsurance.value);
    };
    return {
      order,
      payImage,
      clickCode,
      code,
      msOpen,
      gift_goods,
      changeSelectedSku,
      clickMsItem,
      icons: [
        // {
        //   title: 'cartPreviewSafety',
        //   description: 'cartPreviewSafety_messageinfo',
        //   icon: 'safety'
        // },
        // {
        //   title: 'cartPreviewShipping',
        //   description:
        //     'cartpreviewShipping_messageinfo',
        //   icon: 'shipping'
        // }
      ],
      delCode,
      promoCode,
      coupons,
      couponList,
      selecCouponeChange,
      preorder,
      propertiesNames: [
        'Products',
        'Total',
        'Shipping',
        ('Shipping_Tax'),
        'payment_insurance_fee',
        'payment_insurance_tax',
        'payment_order_discount',
        ('Total_price')
      ],
      servicesList,
      toggleServices,
      address,
      InsuranceShow,
      hasInsurance,
      toggleInsurance
    };
  }
};
</script>
<style lang="scss" scoped>
#detailed-cart {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 360px;
    margin: 0 auto;
    background-color: var(--c-light);
    padding: var(--spacer-xl);
  }
  
  .item-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media (max-width: 1023px) {
    .mobile-only {
      display: block;
    }
  }

  @media (min-width: 1023px) {
    .mobile-only {
      display: none;
    }
  }
}

</style>
<style lang="scss">
#detailed-cart {
  .mansongItem {
    .sf-modal__container {
      width: 100vw;
    }
  }
  .NewSummary{
    .orderImg {
      --_image-width: 64px;
      --_image-height: 64px;
      .sf-image {
        height: 64px;
        width: 64px;
      }
    }
    .item-row{
      margin: 0 ;
      display: flex;
      margin-bottom: 0.25rem;
      .item-cell{
        flex: 1;
        align-content: center;
        .title{
          font-size: 12pt;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .descript{
          font-size: 10pt;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top:5px;
        }
      }
    }
    .sf-order-summary__property{
      margin: var(--spacer-sm) 0 0 0 !important;
    }
    .sf-radio__container{
      padding: 0;
      background:#fff;
    }
    @include for-desktop{
      .isDesktopShow{
        display: block;
      }
      .isMobileShow{
        display: none;
      }
    }
    @include for-mobile{
      .isDesktopShow{
        display: none;
      }
      .isMobileShow{
        display: block;
      }
    }
  }
  .couponeModal1 {
    .sf-modal__container {
      width: 300px;

      @include for-mobile {
        --modal-left: calc((100vw - 300px)/2);
        --modal-height: 300px !important;
        --modal-top: 5rem;
      }
    }
  }

  .codeList {
    display: flex;
  }
}
</style>
